import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentReference, NameValue } from '../../core/models';
import { 
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, 
  ChurchService, DatabaseService, UserService, FestivalUserService, SportTeamService
} from 'src/core/services';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { ModalController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';
import { TextService } from 'src/core/services/text-service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.less']
})

export class AddUserComponent extends PageClass implements OnInit {

  user: any = {
    isActive : true,
    isDeleted : false,
  };

  festivalUser: any = {
    isActive : true,
    isDeleted : false,
    isAdmin : false,
    isChurchApprover : false,
    isSportLeader : false,
    isSportCoordinator : false,
    isAcivityApprover : false,
    isActivityCoordinator : false,
    isActivityLeader : false
  };

  ageGroups: DocumentReference[];
  roleList: string[] = [];
  priestList: DocumentReference[] = [];
  activityList: NameValue[] = [];
  sportList: NameValue[] = [];

  @ViewChild('userForm', null) userForm: NgForm;

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected sportTeamService: SportTeamService,
    protected userService: UserService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController,
    private textService: TextService
  ) {
    super(
      ageGroupService, arrayService, authService, 
      churchService, databaseService, festivalUserService
    );
  }

  protected loadData = async () => {
    
    this.priestList = [];

    this.activityList = this.activityFormatService.getActivityList();
    this.sportList = this.sportTeamService.getSportList();

    if (!this.currentUser.isAdmin) {
      this.dismissModal();
    } else if (this.currentUser.isActive && !this.currentUser.isDeleted) {

      if (localStorage.getItem('filteredChurch'))
        this.user.church = this.churchList.find(c => c.reference.id == localStorage.getItem('filteredChurch'));

      this.user.role = 'Servant';
      this.user.mobile = '04';
      this.getLists();
    }
  }

  private async getLists() {
    this.roleList = this.userService.GetUserRoleList(); 
    (await this.ageGroupService.getAgeGroups()).subscribe( ageGroups => {
      this.ageGroups = [];
      ageGroups.map(a => this.ageGroups.push({
        displayName: a.displayName, 
        reference: this.databaseService.doc(`ageGroups/${a.id}`).ref
      }));

      this.festivalUser.ageGroupList = this.ageGroups;
    });
  }

  public async addUser() {
    if (this.userForm.invalid) {
      return;
    }

    this.user = {
      ...this.user,
      firstName: this.textService.toPascalCase(this.user.firstName),
      lastName: this.textService.toPascalCase(this.user.lastName),
      email: this.textService.toLowerCase(this.user.email)
    };
    
    this.festivalUser = {
      ...this.festivalUser,
      church: this.user.church,    
      email: this.user.email,
      role: this.user.role
    };

    await this.userService.createUser(this.user)
      .then(
        (userId) => {
          this.addFestivalUser(userId);
        });
  }

  private async addFestivalUser(userId: string) {
    await this.festivalUserService.createFestivalUser(this.festivalUser, this.user, userId)
      .then (() => {
        if (environment.sendRegisterEmail) {
          console.log('Email Sent to User');
          this.authService.resetPasswordInit(this.user.email);
        }
        this.dismissModal();
      });
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
